import React from "react";
import { TextArea } from "react-form";

const InputTextField = ({ label, required, ...rest }) => {
  return (
    <div className="field">
      <label className="label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      <p className="control">
        <TextArea className="textarea" required={required} {...rest} />
      </p>
      {/* <p className={`help ${helpClass}`}>{helpMessage}</p> */}
    </div>
  );
};

export default InputTextField;



// WEBPACK FOOTER //
// ./src/components/form-fields/TextArea.js